import React, { useState, useEffect } from "react";

import { LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import axios from "axios";

import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker
} from "@material-ui/pickers";
import { NavLink } from "react-router-dom";
import {get_cookies, isLoggedIn, timeZoneChanger} from "../../../components/Cookies/Cookies";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import LoadingModal from "../../../components/Modal/LoadingModal";
import MessageBox from "../../../components/MessageBox/MessageBox";
import {  useParams, useHistory } from "react-router-dom";
import Preloader from "../../../components/Preloader/Preloader";

const useStyles = makeStyles({
	title: {
		marginTop: 0
	},
	field: {
		width: "100%",
		marginBottom: "1rem"
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem"
	},
	date: {
		width: "100%",
		marginBottom: "1rem"
	},
	buttonContainer: {
		textAlign: "right"
	}
});

const SalesOrder = () => {
	const classes = useStyles();
	const x = 0;

	useEffect(() => {
		//
		getShippingList();
		getWarehouseList();
	}, []);

	const defaultProps = {
		options: selectType,
		getOptionLabel: option => option.title
	};
	const [selectedDate, setSelectedDate] = React.useState(format(new Date(), "yyyy-MM-dd"));
	const [shipping, setShipping] = useState(null);
	const [warehouse, setWarehouse] = useState(null);
	const [branchIdNo, setBranchIdNo] = useState(get_cookies("branchidno"));
	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(true);

	const [trantype, setTrantype] = useState("");
	const [shippingId, setShippingId] = useState(0);
	const [warehouseId, setWarehouseId] = useState(0);
	const [idNo, setIdNo] = useState("");

    const [showMsgBox, setShowMsgBox] = useState(false);
    const [msgBoxContent, setMsg] = useState("Empty");
    const [msgType, setMsgType] = useState("success");
	let history = useHistory();


	const getShippingList = async () => {
		await axios
			.get(process.env.REACT_APP_API_URL + "/get_shipping_list", {
				params: {
					jc_user_id_no: branchIdNo //branchIdNo
				}
			})
			.then(res => {
				setShipping(res.data.data);
			})
			.catch(error => {
			//console.log(error.message);
			});
	};
	const getWarehouseList = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'/get_warehouse_list', {
			params:{
				jc_user_id_no: branchIdNo,  //branchIdNo
			}
		}).then((res)=>{
			setWarehouse(res.data.data);
		}).catch((error)=>{
		//console.log(error.message);
		});
	}
	const validate_idno = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'/sales_order_form_check', {
			params:{
				jc_u_idno: branchIdNo,  //branchIdNo
				trandate: selectedDate, 
				shipping: shippingId, 
				warehouse: warehouseId, 
				idno: idNo, 
				trantype: trantype, 
				curcode: get_cookies('curcode'), 
			}
		}).then((res)=>{
			if(res.data.success == 1){
				history.push("/sales/sales-order-information/"+shippingId+"/"+warehouseId+"/"+idNo+"/"+trantype);
			}else{
				setShowMsgBox(true);
				setMsg(res.data.message);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 4500)
			}
		
		}).catch((error)=>{
		//console.log(error.message);
			setShowMsgBox(true);
			setMsg("ID No not found");
			setMsgType("warning");
			setTimeout(() => {
				setShowMsgBox(false);
				setBtnDisabled(false); // re-enable
			}, 2500)
		});
	}

	const selectShippingProps = {
		options: shipping,
		getOptionLabel: option => option.description
	};

	const selectLocationProps = {
		options: warehouse,
		getOptionLabel: option => option.description
	};

	const handleDateChange = date => {
		setSelectedDate(date);
	};

	useEffect(() => {
		if (idNo && trantype && shippingId && warehouseId) {
			setBtnDisabled(false); // re-enable
		} else {
			setBtnDisabled(true); // re-enable
		}
	}, [idNo, trantype, shippingId, warehouseId]);
		useEffect(() => {
		//
			const newDate = timeZoneChanger(selectedDate);
		setSelectedDate(newDate);
		isLoggedIn();
	}, [x]);


	const ColorButton = withStyles(() => ({
    		root: {
    		  color: "#fff",
    		  backgroundColor: "#4caf50",
    		  '&:hover': {
    		    backgroundColor: "#fff",
    		    color: "#4caf50",
    		  }
    		},
  			}))(Button);


	return (
		<div className="page">
			
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/sales"}>
					<h4 style={{ color: "#1D1C1A" }}>Sales</h4>
				</NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Sales Order</h4>
			</div>
			{shipping&&warehouse ? (<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Grid container spacing={3}>
					<Grid item xs="12" sm="6">
						<Card>
							<CardContent>
								<h4 className={classes.title}>Deliver to</h4>
								<form noValidate autoComplete="off">
									<TextField
										id="outlined-basic"
										label="Enter Id No."
										variant="outlined"
										type="text"
										className={classes.field}
										value={idNo} //to avoid label overlapping bug
										onChange={e => {
											 const value = e.target.value.trim();
											setIdNo(value);
										}}
									/>
									<Autocomplete
										{...defaultProps}
										id="auto-complete"
										autoComplete
										includeInputInList
										className={classes.autoComplete}
										renderInput={params => (
											<TextField
												{...params}
												label="Select Transaction Type"
												margin="normal"
												variant="outlined"
											/>
										)}
										onChange={(event, newValue) => {
											if (
												!newValue == "" ||
												!newValue == null
											) {
												setTrantype(newValue.title);
											}else{
												setTrantype(null);
											}
										}}
									/>
								</form>
							</CardContent>
						</Card>
					</Grid>
					<Grid item xs="12" sm="6">
						<Card>
							<CardContent>
								<h4 className={classes.title}>Deliver from</h4>
								<form noValidate autoComplete="off">
									<MuiPickersUtilsProvider
										utils={DateFnsUtils}
									>
										<KeyboardDatePicker
											disableToolbar
											variant="inline"
											format="MMM dd, yyyy"
											readOnly={true}
											id="date-picker-inline"
											label="Date"
											value={selectedDate}
											// onChange={handleDateChange}
											inputVariant="outlined"
											margin="normal"
											className={classes.date}
											KeyboardButtonProps={{
												"aria-label": "change date"
											}}
											InputProps={{
												readOnly: true,
											  }}
										/>
									</MuiPickersUtilsProvider>
									<Autocomplete
										{...selectShippingProps}
										id="auto-complete-1"
										autoComplete
										includeInputInList
										renderInput={params => (
											<TextField
												{...params}
												label="Select Shipping"
												variant="outlined"
											/>
										)}
										onChange={(event, newValue) => {
											if (
												!newValue == "" ||
												!newValue == null
											) {
												//console.log(newValue.description);
												setShippingId(newValue.id);
											}else{
												setShippingId(null);
											}
										}}
									/>
									<Autocomplete
										{...selectLocationProps}
										id="auto-complete-2"
										autoComplete
										includeInputInList
										renderInput={params => (
											<TextField
												{...params}
												margin="normal"
												label="Select Location"
												variant="outlined"
											/>
										)}
										onChange={(event, newValue) => {
											if (
												!newValue == "" ||
												!newValue == null
											) {
												//console.log(newValue.description);
												setWarehouseId(newValue.id);
											}else{
												setWarehouseId(null);
											}
										}}
									/>
								</form>
							</CardContent>
						</Card>
					</Grid>
					<Grid item xs="12" className={classes.buttonContainer}>
							<ColorButton disabled={btnDisabled} onClick={()=>{validate_idno()}} variant="contained" color="primary" classes={{
    						root: classes.root, 
        					disabled: classes.disabled}}>
								Next
							</ColorButton>
					</Grid>
				</Grid>
			</div>
		) : (<Preloader />)}

		</div>
	);
};

const selectType = [
	{ title: "Regular" },
	{ title: "Representation"}
];

export default SalesOrder;
